import controller from './categories-input-filter.controller';
import template from './categories-input-filter.view.html';

let CategoriesInputFilterComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default CategoriesInputFilterComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/categories-filter/categories-input-filter/categories-input-filter.component.js
 **/